import { useCallback, useState } from 'react';
import { Banner, ModalFormMode } from '../admin-banners.type';
import { emptyValues } from '../admin-banners.constants';

export const useModalForm = () => {
    const [mode, setMode] = useState<ModalFormMode>(ModalFormMode.CLOSE);
    const [initialValues, setInitialValues] = useState<Banner | null>(null);

    const showUpdateForm = (banner: Banner) => {
        setInitialValues({ ...banner });
        setMode(ModalFormMode.UPDATE);
    };

    const showCreateForm = () => {
        setInitialValues({ ...emptyValues });
        setMode(ModalFormMode.CREATE);
    };

    const hideForm = useCallback(() => {
        setMode(ModalFormMode.CLOSE);
    }, []);

    return {
        mode,
        initialValues,
        hideForm,
        showCreateForm,
        showUpdateForm,
    };
};
